import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => (
  <div className="min-h-screen bg-beachvision-bg text-white">
    <div className="mx-auto flex min-h-screen w-full max-w-beachvision-shell flex-col items-center justify-center px-6 text-center">
      <p className="text-xs font-display font-bold uppercase tracking-[0.2em] text-beachvision-teal">
        Beachvision
      </p>
      <h1 className="mt-3 font-display text-4xl font-black tracking-tight text-beachvision-primary-light">
        Smarter Beach Volleyball Training
      </h1>
      <p className="mt-4 text-sm leading-relaxed text-beachvision-muted">
        Upload your session, review point-by-point insights, and focus your next reps with clear coaching takeaways.
      </p>
      <Link
        to="/login/"
        className="mt-8 inline-flex items-center justify-center rounded-xl bg-beachvision-cta px-6 py-3 font-display font-black uppercase tracking-wide text-beachvision-on-coral shadow-lg shadow-beachvision-coral/20 transition hover:brightness-105"
      >
        Go to Login
      </Link>
    </div>
  </div>
);

export default Home;
